import * as XLSX from 'xlsx-js-style';
import { getPreparedData } from './mapping';
import { ExcelTemplate } from 'src/app/domain/excel/interfaces';
import { fitToColumn } from 'src/app/domain/excel/templates/financial-statement/utils';
import { ColumnDate } from 'src/app/domain/financial-statement/utils/common/utilityClasses';
import { FinancialStatementPart } from 'src/app/domain/financial-statement/models/common/FinancialStatementPart';
import { setColumnWidth, withHeaderStyling } from 'src/app/domain/excel/utils';
import { ColumnOrder } from '../../domain/financial-statement/component/bs-page/bs-page.component';

export class BalanceSheetTemplate implements ExcelTemplate {

  export(data: BsExcelExportData): XLSX.WorkBook {
    const book = XLSX.utils.book_new();
    const sheet = this.getSheet(data);
    XLSX.utils.book_append_sheet(book, sheet);
    return book;
  }

  getSheet(exportExcelData: BsExcelExportData): XLSX.WorkSheet {
    const headers = this.getHeadersForLogic();
    const headersForDisplay = this.getHeadersForDisplay(exportExcelData.selectedBasedDataColumns, exportExcelData.selectedPeriod);
    const preparedData = getPreparedData(exportExcelData, headers, headersForDisplay);
    const sheet = {
      ...XLSX.utils.aoa_to_sheet(preparedData),
      '!cols': fitToColumn(preparedData),
    };
    setColumnWidth(sheet, 0, 30);
    return withHeaderStyling(sheet);
  }

  private getHeadersForDisplay(selectedBasedDataColumns: Map<ColumnOrder, ColumnDate>, selectedPeriod: Date): string[] {
    return ['', selectedBasedDataColumns.get(ColumnOrder.FIRST).selectedDate, 'Difference',
      selectedBasedDataColumns.get(ColumnOrder.SECOND).selectedDate, 'Difference',
      selectedBasedDataColumns.get(ColumnOrder.THIRD).selectedDate, 'Difference',
      selectedPeriod.toString()];
  }

  private getHeadersForLogic() {
    return ['', 'Date(0)', 'Difference(0)', 'Date(1)', 'Difference(1)', 'Date(2)', 'Difference(2)', 'Date(3)'];
  }
}

export interface BsExcelExportData {
  selectedBasedDataColumns: Map<ColumnOrder, ColumnDate>;
  parts: FinancialStatementPart[];
  selectedPeriod: Date;
}
